import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Promotion } from '../../domain/models/promotion.model';
import { PromotionInput } from '../../domain/models/promotion-input.model';
import { IPromotionsRepository } from '../../domain/repositories/promotions.repository';
import { PromotionsRemoteDatasource } from '../datasources/remote/promotions.remote-datasource';
import { PromotionMapper } from '../mappers/promotion.mapper';

@Injectable()
export class PromotionsRepositoryImpl implements IPromotionsRepository {
  private readonly datasource = inject(PromotionsRemoteDatasource);
  private readonly mapper = inject(PromotionMapper);

  public list(organizationId: number): Observable<readonly Promotion[]> {
    return this.datasource.list(organizationId).pipe(map((dtos) => dtos.map((dto) => this.mapper.toPromotion(dto))));
  }

  public getById(organizationId: number, promotionId: string): Observable<Promotion> {
    return this.datasource.getById(organizationId, promotionId).pipe(map((dto) => this.mapper.toPromotion(dto)));
  }

  public create(organizationId: number, input: PromotionInput): Observable<Promotion> {
    return this.datasource.create(organizationId, this.mapper.toCreateRequest(input)).pipe(
      map((dto) => this.mapper.toPromotion(dto)),
    );
  }

  public update(organizationId: number, promotionId: string, input: PromotionInput): Observable<Promotion> {
    return this.datasource.update(organizationId, promotionId, this.mapper.toCreateRequest(input)).pipe(
      map((dto) => this.mapper.toPromotion(dto)),
    );
  }

  public delete(organizationId: number, promotionId: string): Observable<void> {
    return this.datasource.delete(organizationId, promotionId);
  }

  public duplicate(organizationId: number, promotionId: string): Observable<Promotion> {
    return this.datasource.duplicate(organizationId, promotionId).pipe(map((dto) => this.mapper.toPromotion(dto)));
  }
}
